import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Also attach Bearer for environments where third-party cookies are blocked
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nrvr_access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Expired/invalid session mid-use: clear it and send the user to the login page with a message
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const url = error.config?.url || "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/me") || url.includes("/auth/logout");
    if (error.response?.status === 401 && !isAuthCall) {
      localStorage.removeItem("nrvr_access_token");
      sessionStorage.setItem("nrvr_flash", "Your session has expired. Please sign in again.");
      if (window.location.pathname !== "/login") window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  // Structured errors from the server: {message, errors:[{path,message}], fields:[...]}
  if (typeof detail === "object" && !Array.isArray(detail) && detail.message) {
    const list = Array.isArray(detail.errors) ? detail.errors.map((e) => `${e.path}: ${e.message}`)
      : Array.isArray(detail.fields) ? detail.fields : [];
    return list.length ? `${detail.message} — ${list.slice(0, 5).join("; ")}${list.length > 5 ? "…" : ""}` : detail.message;
  }
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
